import THREE from "../Three";
import { COLOURS } from "../../styles/variables/Colors";

export default class Scene {
  constructor(scene, renderer) {
    this.scene = scene;
    this.renderer = renderer;
    this.element = scene.userData.element;
    this.container = document.body;

    this.frustumSize = 8.0;
    this.aspect = 1;

    this.camera = new THREE.OrthographicCamera(
      (this.frustumSize * this.aspect) / -2,
      (this.frustumSize * this.aspect) / 2,
      this.frustumSize / 2,
      this.frustumSize / -2,
      -1000,
      2000
    );

    this.onResize = this.onResize.bind(this);

    this.settings();
    this.effectSettings();
    this.createEventListeners();
  }

  settings() {
    this.renderer.setClearColor(0x000000, 0);
  }

  effectSettings() {
    this.effect = new THREE.AsciiEffect(this.renderer, " .:-+*=RASDW", {
      invert: true,
      background: "transparent",
    });
    this.effect.setSize(window.innerWidth, window.innerHeight);
    this.effect.domElement.style.color = COLOURS.primary.yellow;
    this.effect.domElement.style.backgroundColor = "transparent";
    this.effect.domElement.willReadFrequently = true;
    this.element.appendChild(this.effect.domElement);
  }

  triggerEffects() {
    this.effect.render(this.scene, this.camera);
  }

  createEventListeners() {
    window.addEventListener("resize", this.onResize);
  }

  render() {}

  onResize() {
    this.camera.aspect = window.innerWidth / window.innerHeight;
    this.camera.updateProjectionMatrix();
    this.effect.setSize(window.innerWidth, window.innerHeight);
  }
}
